import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-38507c48"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "scroll-view-wrapper new_exercise" };
const _hoisted_2 = { class: "head" };
const _hoisted_3 = { class: "study_time" };
const _hoisted_4 = {
    key: 0,
    class: "default_title"
};
const _hoisted_5 = { key: 1 };
const _hoisted_6 = /*#__PURE__*/ _createTextVNode(" 在好医术第");
const _hoisted_7 = /*#__PURE__*/ _createTextVNode("天，共学");
const _hoisted_8 = /*#__PURE__*/ _createTextVNode("小时 ");
const _hoisted_9 = { class: "new_exercise_container" };
const _hoisted_10 = { class: "study_num" };
const _hoisted_11 = { class: "item lesson" };
const _hoisted_12 = /*#__PURE__*/ _createTextVNode("节 ");
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "text" }, "课程", -1));
const _hoisted_14 = { class: "item train" };
const _hoisted_15 = /*#__PURE__*/ _createTextVNode("次 ");
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "text" }, "训练/共学营", -1));
const _hoisted_17 = { class: "item exam" };
const _hoisted_18 = /*#__PURE__*/ _createTextVNode("题 ");
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "text" }, "病例练习", -1));
const _hoisted_20 = { class: "tabWrapper" };
const _hoisted_21 = { class: "list1 font-36" };
const _hoisted_22 = ["onClick"];
const _hoisted_23 = { class: "list2 clearfix p-lr32 listTwo subTabList" };
const _hoisted_24 = ["onClick"];
const _hoisted_25 = { class: "list3 clearfix font-28" };
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "学习中", -1));
const _hoisted_27 = [
    _hoisted_26
];
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "已学完", -1));
const _hoisted_29 = [
    _hoisted_28
];
const _hoisted_30 = { class: "courseWrapper p-lr32" };
const _hoisted_31 = {
    key: 1,
    class: "noMore"
};
import { onMounted, ref, getCurrentInstance, nextTick, onUnmounted } from 'vue';
import { hostPath } from '@utils/basePath';
import { getLearnInfo, getDepId } from '@/api/user';
import BetterScroll from '@/components/common/BetterScroll.vue';
import { appPort, jumpModuleApp, getUserId, getTokenObj, getDomWidth } from '@/widget';
import { useRouter, useRoute } from 'vue-router';
import { getStudyTab, getStudyCourseList } from '@/api/home';
import { find } from 'lodash-es';
// import { CourseListItem } from '@/types/course'
import Empty from '@/components/common/Empty.vue';
import CourseList from '@/components/course/courseList.vue';
import AppTopBar from '@/components/common/AppTopBar.vue';
import { useAppPageBar } from '@/hooks/appPage';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const { barH } = useAppPageBar();
        const scrollY = ref(0);
        const scrollFn = (e) => {
            if (isApp) {
                scrollY.value = e.y;
            }
        };
        const { proxy: { $toast } } = getCurrentInstance();
        const isApp = ref(appPort());
        const userId = ref(getUserId());
        // 是否登录
        const isLogin = ref(Boolean(getTokenObj().token));
        const currentRoute = useRoute();
        const $router = useRouter();
        // 进入排名页
        const pageAction = () => {
            if (isApp.value) {
                jumpModuleApp({
                    typeId: 'h5',
                    url: `${hostPath}/learn/exercise/rank`
                });
            }
            else {
                $router.push('/exercise/rank');
            }
        };
        // 学习统计
        const learnInfo = ref({});
        const getUserInfo = () => {
            getLearnInfo({
                userId: userId.value
            }).then(res => {
                if (res.code === 200) {
                    learnInfo.value = res.data;
                }
                else {
                    $toast(res.message);
                }
            });
        };
        // 获取用户科室信息
        const departmentId = ref(0);
        const getUseDep = () => {
            getDepId(userId.value).then(res => {
                if (res.code === 200) {
                    departmentId.value = res.data.depId;
                    nextTick(() => {
                        getPageInfo();
                    });
                }
                else {
                    $toast(res.message);
                }
            });
        };
        const tabList = ref([]);
        const type = ref(String(currentRoute.query.type || 'master_class'));
        const subType = ref(String(currentRoute.query.subType || ''));
        const activeType = ref({});
        const subTypeList = ref([]);
        const finish = ref(false);
        const listW = ref(6.6);
        const tabBl = ref(false);
        // 获取列表
        const getPageInfo = async () => {
            await getStudyTab(userId.value, {
                departmentId: departmentId.value
            }).then((res) => {
                if (res.code == 200) {
                    tabList.value = res.data.typeList;
                    activeType.value = find(tabList.value, { id: type }) || tabList.value[0];
                    subTypeList.value = activeType.value.detailTypeList;
                    if (!find(subTypeList, { id: subType }) && subTypeList.value.length) {
                        subType.value = subTypeList.value[0].id;
                    }
                    getList(true);
                }
            });
            getWidth();
        };
        const getWidth = () => {
            listW.value = 7.5;
            tabBl.value = false;
            nextTick(() => {
                let dom = document.querySelector('.listTwo');
                if (dom) {
                    listW.value = getDomWidth(dom, 68, 16);
                }
                tabBs.value?.refreshBs();
            });
        };
        // 选择课程类型
        const selectType = (item) => {
            if (item.id == type.value) {
                return;
            }
            type.value = item.id;
            activeType.value = item;
            subTypeList.value = item.detailTypeList;
            subType.value = subTypeList.value[0]?.id || '';
            getWidth();
            getList(true);
        };
        // 计算要滚动的距离
        const countLeft = (className) => {
            if (!className) {
                return 0;
            }
            let parent = document.querySelector('.' + className);
            let child = document.querySelector('.' + className + ' .active');
            if (!parent || !child) {
                return 0;
            }
            // 父元素宽度
            let pw = parent?.offsetWidth;
            let cw = child?.offsetWidth;
            let cw2 = parseInt(cw / 2 + '', 10);
            let cl = child?.offsetLeft;
            let cr = pw - cw - cl; // 元素距离右侧距离
            let ww = window.innerWidth;
            let ww2 = parseInt(ww / 2 + '', 10);
            if (ww2 > cw2 + cl || pw < ww) {
                return 0;
            }
            else if (cr < ww2) {
                return ww - pw;
            }
            else {
                return ww2 - (cl + cw2);
            }
        };
        // 选择子类
        const selectSubType = (item) => {
            if (item.id == subType.value) {
                return;
            }
            subType.value = item.id;
            getList(true);
            nextTick(() => {
                // active 渲染后移动
                tabBs.value?.scrollTo(countLeft('subTabList'), 0);
            });
        };
        // 选择学习状态
        const selectStatus = (bl) => {
            finish.value = bl;
            getList(true);
        };
        // 列表是否加载完成
        const loaded = ref(false);
        const list = ref([]);
        let pageNo = 1;
        let pageCount = 1;
        const noMore = ref(false);
        let loading = false; // 数据是否加载中
        const getList = (bl) => {
            if (loading) {
                return;
            }
            if (bl) {
                pageNo = 1;
            }
            loading = true;
            loaded.value = false;
            getStudyCourseList(userId.value, {
                finish: finish.value,
                departmentId: departmentId.value,
                type: type.value,
                detailType: subType.value,
                pageNo,
                pageSize: 10
            }).then((res) => {
                loading = false;
                loaded.value = true;
                tabBl.value = true;
                if (res.code == 200) {
                    pageCount = res.data.pageCount;
                    if (pageNo == 1) {
                        list.value = res.data.list || [];
                    }
                    else {
                        list.value = list.value.concat(res.data.list);
                    }
                    if (pageNo >= pageCount) {
                        noMore.value = true;
                    }
                    else {
                        noMore.value = false;
                        pageNo++;
                    }
                }
            });
        };
        // 更新页面数据
        const listBs = ref();
        const tabBs = ref();
        onMounted(() => {
            window.updateListData = () => {
                listBs.value?.refreshBs();
                tabBs.value?.refreshBs();
            };
            if (isLogin.value) {
                getUseDep();
                getUserInfo();
            }
        });
        onUnmounted(() => {
            if (window.updateListData) {
                delete window.updateListData;
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (isApp.value)
                    ? _withDirectives((_openBlock(), _createBlock(AppTopBar, {
                        key: 0,
                        fixed: true,
                        background: 'gray'
                    }, null, 512)), [
                        [_vShow, _unref(barH) + scrollY.value <= 0]
                    ])
                    : _createCommentVNode("", true),
                _createVNode(BetterScroll, {
                    options: {
                        scrollY: true,
                        scrollX: false,
                        click: true,
                        mouseWheel: false,
                        scrollbar: {
                            fade: false,
                            interactive: true
                        },
                        pullUpLoad: {
                            threshold: 3
                        }
                    },
                    noMore: noMore.value,
                    loaded: loaded.value,
                    onUpLoad: getList,
                    domStyle: {
                        position: 'relative',
                        height: '100vh'
                    },
                    onScrollFn: scrollFn,
                    ref: (_value, _refs) => {
                        _refs['listBs'] = _value;
                        listBs.value = _value;
                    }
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", {
                            class: _normalizeClass(["new_exercise_header", { app: isApp.value }])
                        }, [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, [
                                    (!isLogin.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, "赋能医生，守护生命"))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                            _hoisted_6,
                                            _createElementVNode("span", null, _toDisplayString(learnInfo.value.day || 0), 1),
                                            _hoisted_7,
                                            _createElementVNode("span", null, _toDisplayString(learnInfo.value.studyTime || 0), 1),
                                            _hoisted_8
                                        ]))
                                ]),
                                _createElementVNode("i", {
                                    class: "ranking",
                                    onClick: pageAction
                                })
                            ])
                        ], 2),
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("p", null, [
                                        _createElementVNode("strong", null, _toDisplayString(learnInfo.value.albumCount), 1),
                                        _hoisted_12
                                    ]),
                                    _hoisted_13
                                ]),
                                _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("p", null, [
                                        _createElementVNode("strong", null, _toDisplayString(learnInfo.value.meetingCount), 1),
                                        _hoisted_15
                                    ]),
                                    _hoisted_16
                                ]),
                                _createElementVNode("div", _hoisted_17, [
                                    _createElementVNode("p", null, [
                                        _createElementVNode("strong", null, _toDisplayString(learnInfo.value.questionCount), 1),
                                        _hoisted_18
                                    ]),
                                    _hoisted_19
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("ul", _hoisted_21, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (item) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        class: _normalizeClass({
                                            active: item.id == type.value
                                        }),
                                        onClick: _withModifiers(($event) => (selectType(item)), ["stop"])
                                    }, _toDisplayString(item.name), 11, _hoisted_22));
                                }), 256))
                            ]),
                            _withDirectives(_createVNode(BetterScroll, {
                                domStyle: {
                                    position: 'relative',
                                    height: '0.8rem'
                                },
                                wrapperStyle: {
                                    width: listW.value + 'rem'
                                },
                                ref: (_value, _refs) => {
                                    _refs['tabBs'] = _value;
                                    tabBs.value = _value;
                                },
                                loaded: tabBl.value,
                                options: {
                                    scrollY: false,
                                    scrollX: true,
                                    click: false,
                                    mouseWheel: false,
                                    scrollbar: {
                                        fade: false,
                                        interactive: true
                                    }
                                }
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("ul", _hoisted_23, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subTypeList.value, (sub) => {
                                            return (_openBlock(), _createElementBlock("li", {
                                                class: _normalizeClass(["float-l font-28", { active: subType.value == sub.id }]),
                                                onClick: _withModifiers(($event) => (selectSubType(sub)), ["stop"])
                                            }, [
                                                _createElementVNode("span", null, _toDisplayString(sub.name), 1)
                                            ], 10, _hoisted_24));
                                        }), 256))
                                    ])
                                ]),
                                _: 1
                            }, 8, ["domStyle", "wrapperStyle", "loaded"]), [
                                [_vShow, subTypeList.value.length]
                            ]),
                            _createElementVNode("ul", _hoisted_25, [
                                _createElementVNode("li", {
                                    class: _normalizeClass(["float-l", {
                                            active: finish.value == false
                                        }]),
                                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (selectStatus(false)), ["stop"]))
                                }, _hoisted_27, 2),
                                _createElementVNode("li", {
                                    class: _normalizeClass(["float-l", {
                                            active: finish.value == true
                                        }]),
                                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (selectStatus(true)), ["stop"]))
                                }, _hoisted_29, 2)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                            _createVNode(CourseList, {
                                list: list.value,
                                process: true
                            }, null, 8, ["list"]),
                            (list.value.length == 0 && loaded.value)
                                ? (_openBlock(), _createBlock(Empty, { key: 0 }))
                                : _createCommentVNode("", true),
                            (noMore.value && list.value.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, "没有更多了"))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _: 1
                }, 8, ["noMore", "loaded"])
            ]));
        };
    }
});
